export const isNumeric = (n) => {
  return !isNaN(parseFloat(n)) && isFinite(n)
}

export const isValidObject = (obj) => {
  return obj && typeof obj === 'object' && Object.keys(obj).length
}

export const isTouchDevice = () => {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  )
}

export const getScrollbarWidth = () => {
  return window.innerWidth - document.body.clientWidth
}
